module.exports = __webpack_public_path__ + "media/images/cloud-316fd2f97987ea290a4958396c775082.png";